import { Component, ElementRef, NgZone, Input, NgModule } from '@angular/core';
import OverlayScrollbars from 'overlayscrollbars';

import * as ɵngcc0 from '@angular/core';

var _c0 = ["*"];
var OverlayScrollbarsComponent = (function () {
    function OverlayScrollbarsComponent(_osTargetRef, ngZone) {
        this.ngZone = ngZone;
        this._osInstance = null;
        this._osTargetRef = _osTargetRef;
    }
    OverlayScrollbarsComponent.prototype.osInstance = function () {
        return this._osInstance;
    };
    OverlayScrollbarsComponent.prototype.osTarget = function () {
        return this._osTargetRef.nativeElement || null;
    };
    OverlayScrollbarsComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.ngZone.runOutsideAngular((function () {
            _this._osInstance = OverlayScrollbars(_this.osTarget(), _this._options || {}, _this._extensions);
        }));
    };
    OverlayScrollbarsComponent.prototype.ngOnDestroy = function () {
        if (OverlayScrollbars.valid(this._osInstance)) {
            this._osInstance.destroy();
            this._osInstance = null;
        }
    };
    OverlayScrollbarsComponent.prototype.ngOnChanges = function (changes) {
        var optionsChange = changes._options;
        if (optionsChange && OverlayScrollbars.valid(this._osInstance)) {
            this._osInstance.options(optionsChange.currentValue);
        }
    };
    OverlayScrollbarsComponent.ctorParameters = function () { return [
        { type: ElementRef },
        { type: NgZone }
    ]; };
    OverlayScrollbarsComponent.propDecorators = {
        _options: [{ type: Input, args: ['options',] }],
        _extensions: [{ type: Input, args: ['extensions',] }]
    };
OverlayScrollbarsComponent.ɵfac = function OverlayScrollbarsComponent_Factory(t) { return new (t || OverlayScrollbarsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
OverlayScrollbarsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: OverlayScrollbarsComponent, selectors: [["overlay-scrollbars"]], hostAttrs: [1, "os-host"], inputs: { _options: ["options", "_options"], _extensions: ["extensions", "_extensions"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c0, decls: 12, vars: 0, consts: [[1, "os-resize-observer-host"], [1, "os-padding"], [1, "os-viewport"], [1, "os-content"], [1, "os-scrollbar", "os-scrollbar-horizontal"], [1, "os-scrollbar-track"], [1, "os-scrollbar-handle"], [1, "os-scrollbar", "os-scrollbar-vertical"], [1, "os-scrollbar-corner"]], template: function OverlayScrollbarsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1)(2, "div", 2)(3, "div", 3);
        ɵngcc0.ɵɵprojection(4);
        ɵngcc0.ɵɵelementEnd()()();
        ɵngcc0.ɵɵelementStart(5, "div", 4)(6, "div", 5);
        ɵngcc0.ɵɵelement(7, "div", 6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(8, "div", 7)(9, "div", 5);
        ɵngcc0.ɵɵelement(10, "div", 6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelement(11, "div", 8);
    } }, styles: ["[_nghost-%COMP%] { display: block; }"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayScrollbarsComponent, [{
        type: Component,
        args: [{
                selector: 'overlay-scrollbars',
                host: { 'class': 'os-host' },
                template: "\n        <div class=\"os-resize-observer-host\"></div>\n        <div class=\"os-padding\">\n            <div class=\"os-viewport\">\n                <div class=\"os-content\">\n                    <ng-content></ng-content>\n                </div>\n            </div>\n        </div>\n        <div class=\"os-scrollbar os-scrollbar-horizontal \">\n            <div class=\"os-scrollbar-track\">\n                <div class=\"os-scrollbar-handle\"></div>\n            </div>\n        </div>\n        <div class=\"os-scrollbar os-scrollbar-vertical\">\n            <div class=\"os-scrollbar-track\">\n                <div class=\"os-scrollbar-handle\"></div>\n            </div>\n        </div>\n        <div class=\"os-scrollbar-corner\"></div>\n    ",
                styles: [':host { display: block; }']
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { _options: [{
            type: Input,
            args: ['options']
        }], _extensions: [{
            type: Input,
            args: ['extensions']
        }] }); })();
    return OverlayScrollbarsComponent;
}());

var OverlayscrollbarsModule = (function () {
    function OverlayscrollbarsModule() {
    }
OverlayscrollbarsModule.ɵfac = function OverlayscrollbarsModule_Factory(t) { return new (t || OverlayscrollbarsModule)(); };
OverlayscrollbarsModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: OverlayscrollbarsModule });
OverlayscrollbarsModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OverlayscrollbarsModule, [{
        type: NgModule,
        args: [{
                imports: [],
                declarations: [OverlayScrollbarsComponent],
                exports: [OverlayScrollbarsComponent]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(OverlayscrollbarsModule, { declarations: [OverlayScrollbarsComponent], exports: [OverlayScrollbarsComponent] }); })();
    return OverlayscrollbarsModule;
}());

export { OverlayScrollbarsComponent, OverlayscrollbarsModule };

